import styled from "styled-components";

export const HeaderComponent = styled.div`
  box-shadow: 0px 9.15789px 21.4429px rgba(0, 0, 0, 0.0655718), 0px 2.72654px 6.3841px rgba(0, 0, 0, 0.0444282);
  justify-content: space-between;
  background-color: #F2F2F2;
  padding: 30px 40px;
  border-radius: 8px;
  position: fixed;
  height: 153px;
  display: flex;
  width: 100%;
  z-index: 20;
  left: 0;
  top: 0;
  
  &.header-container{
    &.hidden-header{
      .customer-info{
        display: none;
      }
      height: 120px !important;
    }
  }
`;

export const HeaderInfo = styled.div`
  .customer-info{
    border-bottom: 1px solid #BEBEBE;
    padding-bottom: 15px;
  }

  .main-title{
    max-width: 860px;
    margin-right: 20px;
    font-weight: 700;
    font-size: 24px !important;
    white-space: nowrap;
    overflow: hidden; 
    text-overflow: ellipsis;  
  }

  .sub-title{
    align-self: flex-end;
  }

  .quote-solicitation{
    grid-template-columns: minmax(30px,74px) minmax(75px,120px) 380px minmax(80px,140px) minmax(40px,90px) minmax(90px,120px);
    padding-top: 15px;
    display: grid;

    p{
      max-width: 330px;
    }

    .solicitation-title{
      p{
        font-size: 12px !important;
        color: #858585;
      }
    }

    .solicitation-data{
      p{
        font-size: 14px !important;
        font-weight: 700;
        color: #364863;
      }
    }
  }
`;

